import { Component } from '@angular/core';

@Component({
  selector: 'adkom-no-rights',
  templateUrl: './no-rights.component.html',
  styleUrls: ['./no-rights.component.scss'],
})
export class NoRightsComponent {}
